import { Flex, Spinner } from "@radix-ui/themes";

export const FullSpinner: React.FC = () => (
  <Flex justify="center" align="center">
    <Spinner size="3" />
  </Flex>
);
